import ModelPrintView from './ModelPrintView';
import { withI18n } from 'react-i18next';

export default withI18n()(ModelPrintView);
